module.exports = __webpack_public_path__ + "img/化生.2754b111.png";